import { Request } from "@/utils";
import config from "@/configs";

//账户设置
export async function getBanner(params) {
  return Request.get(config.banner, { params });
}

//矿机列表
export async function findMachine() {
  return Request.get(config.findMachine);
}

//获取币价
export async function getDayEarn() {
  return Request.get(config.getDayEarn);
}
//计算器
export async function getComputing(params) {
  return Request.get(config.getComputing, { params });
}

// 电费报表
export async function electricCharge(data) {
  return Request.post(config.electricCharge, data);
}
// 运行时长报表
export async function minerWorkTime(data) {
  return Request.post(config.minerWorkTime, data);
}
// 月账单报表

//获取币价
export async function getBchPrice() {
  return Request.get(config.getBchPrice);
}

// 0费率活动
export async function getZeroRate(params) {
  return Request.get(config.getZeroRate, { params });
}

// 设置用户语言
export async function setLanguage(data) {
  return Request.post(config.setLanguage, data);
}
